<template>
  <v-dialog v-model="dialog" persistent max-width="480px">
    <v-card>
      <v-card-title class="font-weight-bold mx-3">
        {{ $t("Order.NotComplyOrderRulesTitle") }}
        <v-spacer></v-spacer>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 text-center subtitle-1">
        <v-toolbar flat class="transparent-background-color">
          <v-row no-gutters>
            <span class="subtitle-2 font-weight-bold danger--text text-left">
              {{ message }}
            </span>
          </v-row>
        </v-toolbar>
        <v-divider />
        <v-data-table
          v-if="!group"
          :headers="headers"
          :items="materialArr"
          :items-per-page="5"
          no-data-text=""
          dense
        >
          <template v-slot:item.num="{ item }">
            <span class="danger--text">{{ item.num | formatTwoDot }}</span>
          </template>
        </v-data-table>
        <!-- 标配规则 -->
        <v-data-table
          v-else
          :headers="headers"
          :items="materialArr"
          no-data-text=""
          group-by="group_id"
          disable-pagination
          hide-default-footer
          dense
        >
          <template v-slot:group.header="{ isOpen, toggle, group, items }">
            <td :colspan="headers.length - 1" class="text-left subtitle-2">
              {{
                $t("Order.DetailFields.auto_standard_rule_group", [
                  items[0].group_id,
                  items[0].all_count,
                ])
              }}
            </td>
            <td align="center" @click="toggle">
              <v-icon class="pe-1" size="30px" v-if="!isOpen"
                >fa-angle-down</v-icon
              >
              <v-icon class="pe-1" size="30px" v-else>fa-angle-up</v-icon>
            </td>
          </template>
          <template v-slot:item.num="{ item }">
            <span class="danger--text">{{ item.num | formatTwoDot }}</span>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="accent" outlined depressed @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";
export default {
  name: "ErrorMaterialsAlert",

  props: {
    value: Boolean,
    title: String,
    message: String,
    materialArr: Array,
    group: Boolean,
  },

  computed: {
    headers: () => {
      return [
        {
          text: i18n.t("Order.DetailFields.category"),
          align: "start",
          value: "category_name",
        },
        {
          text: i18n.t("Order.DetailFields.material_code"),
          align: "start",
          value: "material_code",
        },
        {
          text: i18n.t("Order.DetailFields.material_name"),
          align: "start",
          value: "material_name",
        },
        {
          text: i18n.t("Order.DetailFields.apply_num"),
          align: "start",
          value: "num",
        },
      ];
    },
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
};
</script>